import { Button } from 'components/Button'
import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const IngredientsRoot = styled('div', {
  width: '100%',
  background: '$accent-white',
  position: 'relative',

  '& .dashed-line': {
    border: 'none',
    borderTop: '2px dashed rgba(0, 0, 0, 0.20)',
    margin: '10px 0',
    alignSelf: 'stretch',
  },

  '& .m-only': {
    display: 'block',
  },
  '& .d-only': {
    display: 'none',
  },
  '@bp2': {
    '& .m-only': {
      display: 'none',
    },
    '& .d-only': {
      display: 'block',
    },
    '& .dashed-line': {
      margin: '20px 0',
    },
  },
})

export const IngredientsContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '$2 $2 80px',
  maxWidth: '1292px',
  margin: 'auto',

  '@bp2': {
    flexDirection: 'row',
    justifyContent: 'center',
    padding: '48px 16px',
  },
})

export const Title = styled('h2', {
  fontSize: '$h3',
  lineHeight: '$h3',
  letterSpacing: '$h3',
  margin: '$1 0',
  width: '100%',
  maxWidth: '260px',

  '@bp2': {
    margin: '$2 0',
    maxWidth: 'none',
  },
})

export const Subtitle = styled(Text, {
  width: '100%',
  maxWidth: '300px',

  '@bp2': {
    maxWidth: 'none',
  },
})

export const IngredientList = styled('div', {
  textAlign: 'center',
  margin: '8px 0px 16px',
  width: '100%',
  maxWidth: '340px',

  '@bp2': {
    margin: '16px 0px',
    maxWidth: 'none',
  },
})

export const TryButton = styled(Button, {
  margin: '$1 0',
  width: '100%',
  maxWidth: '273px',
})

export const ImageColumn = styled('div', {
  display: 'flex',
  flex: '1 1 100%',
  '@bp2': {
    flex: '1 1 50%',
    justifyContent: 'flex-end',
    paddingRight: '$4',
  },
  '@bp3': {
    paddingRight: '$8',
  },
})

export const ImageWrapper = styled('div', {
  width: '253px',
  overflow: 'hidden',
  position: 'relative',
  margin: '$1 43px 0 0',

  '@bp2': {
    width: 'auto',
    maxWidth: '538px',
    margin: 'auto',
  },
})

export const SelectionWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: '$3',
  margin: '16px 0px 8px',

  'div, a': {
    textAlign: 'center',
  },

  '@bp2': {
    margin: '$5 0px 0px',
    gap: '$5',
  },
})

export const Label = styled('p', {
  marginTop: '$1',
  fontSize: '$1',
})

export const RecipeOption = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  alignItems: 'center',
    maxWidth: '92px',
    width: '100%',
    cursor: 'pointer',
  '@bp2': {
    maxWidth: 'none',
  }
})

export const ProteinSelectWrapper = styled('div', {
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '4px',
  
})

export const CopyColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 100%',
  alignItems: 'center',
  textAlign: 'center',
  '@bp2': {
    flex: '1 1 50%',
    alignItems: 'flex-start',
    textAlign: 'left',
  },
})

export const BowlIcon = styled('div', {
  position: 'relative',
  width: '60px',
  height: '60px',

  '@bp2': {
    width: '111px',
    height: '111px',
  },
})

export const ActiveIndicator = styled('div', {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-51%, -50%)',
  borderRadius: '$round',
  border: '2px solid $secondary-500',

  width: '67px',
  height: '67px',

  display: 'none',

  '@bp2': {
    width: '118px',
    height: '118px',
    border: '3px solid $secondary-500',
    transform: 'translate(-51%, -53%)',
  },

  variants: {
    active: {
      true: {
        display: 'block',
      },
    },
  },
})

export const FloatText = styled(Text, {
  position: 'static',
  color: '$accent-black',
  fontWeight: '$regular',
  marginTop: '6px',

  '@bp2': {
    margin: 0,
    color: '$accent-white',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontWeight: '$semiBold',
  },
})
